export default {
    appointment: {
        // Gets all appointments
        list: {
            type: "get",
            error: {
                default: "Unable to load appointments.",
            },
        },
        /*Params:
        * - #patientID?: The patient ID to load appointments for
        *   - If not provided, will load for current user.
        */
        // Gets an appointment
        getAppointment: {
            type: "get",
            error: {
                default: "Unable to load appointment.",
            },
        },
        /*Params:
        * - #patientID: The patient ID for this appointment
        * - #appointmentID: The appointment ID to get
        *  - If null, will retrieve all appointments for auth user.
        */

        // Updates or creates an appointment
        saveAppointment: {
            type: "put",
            success: {
                201: "Successfully added appointment.",
                default: "Successfully saved appointment.",
            },
            error: {
                default: "Unable to save appointment.",
            },
        },
        /*Params:
        * - #patientID: The patient ID for this appointment
        * - <"+>appointment: The appointment data to save
        *  - If AppointmentID is null, it will be created
        */

        // Gets note for provided appointment ID
        getNote: {
            type: "get",
            error: {
                default: "Unable to load appointment note.",
            },
        },
        /*Params:
        * - #appointmentID: The appointment ID to fetch the note for.
        */

        // Gets all notes for patient
        getNotes: {
            type: "get",
            error: {
                default: "Unable to load notes.",
            },
        },
        /*Params:
        * - #patientID?: The patient ID to fetch notes for.
        *   - Defaults to logged in patient.
        */

        // Updates or creates note for provided appointment ID
        saveNote: {
            type: "put",
            error: {
                default: "Unable to save appointment note.",
            },
        },
        /*Params:
        * - #appointmentID: The appointment ID to fetch the note for.
        * - <"+>note: The note data to update or create
        * - If note["AppointmentID"] is null, create
        * - Otherwise, update
        */

        // Signs note for provided appointment ID
        signNote: {
            type: "patch",
            success: {
                default: "Successfully signed appointment note.",
            },
            error: {
                default: "Unable to sign appointment note.",
            },
        },
        /*Params:
        * - #appointmentID: The appointment ID for the note to sign.
        */

        // Unsigns note for provided appointment ID
        unsignNote: {
            type: "patch",
            success: {
                default: "Successfully unsigned appointment note.",
            },
            error: {
                default: "Unable to unsign appointment note.",
            },
        },
        /*Params:
        * - #appointmentID: The appointment ID for the note to unsign.
        */

        // Gets procedures for provided appointment ID
        getProcedures: {
            type: "get",
            error: {
                default: "Unable to load appointment procedures.",
            },
        },
        /*Params:
        * - #appointmentID: The appointment ID to fetch the procedures for.
        */

        // Updates or creates procedures for provided appointment ID
        saveProcedures: {
            type: "put",
            error: {
                default: "Unable to save appointment procedures.",
            },
        },
        /*Params:
        * - #appointmentID: The appointment ID to update the procedures for.
        * - <"+>procedures: The procedures data to update or create
        */

        // Gets export data for provided appointment ID
        getExportData: {
            type: "get",
            error: {
                default: "Unable to load appointment export data.",
            },
        },
        copyNote: {
            type: "patch",
            success: {
                default: "Successfully copy last appointment note.",
            },
            error: {
                default: "Unable to copy last appointment note.",
            },
        },

        deleteAppointment: {
            type: "delete",
            success: {
                default: "Successfully deleted appointment",
            },
            error: {
                default: "Failed to delete appointment.",
            },
        },
        getRecurrenceCount: {
            type: "get",
            error: {
                default: "Unable to get appointment recurrence count.",
            },
        },
        getAssessments: {
            type: "get",
            error: {
                default: "Unable to get assessment list.",
            },
        },
        getClientCoPayment: {
            type: "get",
            error: {
                default: "Unable to get client copayment",
            },
        }
    },
    billing: {
        // Gets a list of active procedures
        listProcedures: {
            type: "get",
            error: {
                default: "Unable to load procedures.",
            },
        },

        // Gets all procedures under a patient
        getProcedures: {
            type: "get",
            error: {
                default: "Unable to load procedures.",
            },
        },
        /*Params:
        * - #patientID: The patient ID to get procedures for
        */

        // Gets all payments a patient has made
        getPayments: {
            type: "get",
            error: {
                default: "Unable to load payments.",
            },
        },
        /*Params:
        * - #patientID: The patient ID to get payments for
        */

        // Gets insurance payments for a patient
        getInsurance: {
            type: "get",
            error: {
                default: "Unable to load insurance payments.",
            },
        },
        /*Params:
        * - #patientID: The patient ID to get insurance for
        */

        // Gets patient's overall balance
        getBalance: {
            type: "get",
            error: {
                default: "Unable to load balance.",
            },
        },

        
    },
}